// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jb-0";
export var animationContainer = "_jb-1";
export var itemPrice = "_jb-a";
export var itemizedContent = "_jb-9";
export var itemizedHeader = "_jb-7";
export var itemizedRow = "_jb-8";
export var itemizedSection = "_jb-6";
export var modalContent = "_jb-2";
export var orderName = "_jb-3";
export var refundOption = "_jb-4";
export var refundOptionsContainer = "_jb-5";
export var shippingLabel = "_jb-b";
export var totalRow = "_jb-c";